import { ITinhTrangNoMonRequest } from "../../model/request/tinh-trang-no-mon/ITinhTrangNoMonRequest";
import { apiClient } from "../apiClient";

const TINH_TRANG_NO_MON_ENDPOINT = 'tinh-trang-no-mon';

export const tinhTrangNoMonApi = {
    SelectAll: (request: ITinhTrangNoMonRequest) => apiClient.post(`${TINH_TRANG_NO_MON_ENDPOINT}/tong-hop`, request),
}